import React from "react";
import useSmartviewManager from "../hooks/use-smartview-manager";
import useOnSmartviewClickOutside from "../hooks/use-on-smartview-click-outside";

export default function GoToPreviousSmartviewOnClickOutside() {

    const manager = useSmartviewManager();

    useOnSmartviewClickOutside(() => {
        manager.back()
    });

    return null;
}
